'use client'

import { type FC } from 'react'

import { SearchPageAdBanner } from '../components/SearchPageAdBanner'
import { type SearchPageAdBannerComponentProps } from '../components/SearchPageAdBanner/SearchPageAdBannerTypes'

import {
  SEARCH_PAGE_AD_BANNER_SEARCH_MIDDLE,
  SEARCH_PAGE_AD_BANNER_SEARCH_MIDDLE_DIMENSIONS,
} from './SearchPageAdBannerConfig'

export const SearchPageAdBannerMiddle: FC<SearchPageAdBannerComponentProps> = ({
  bannerClasses,
  wrapperComponent,
}) => (
  <SearchPageAdBanner
    bannerClasses={bannerClasses}
    bannerTags={[SEARCH_PAGE_AD_BANNER_SEARCH_MIDDLE]}
    dimensions={SEARCH_PAGE_AD_BANNER_SEARCH_MIDDLE_DIMENSIONS}
    wrapperComponent={wrapperComponent}
  />
)
